/* eslint-disable no-nested-ternary */
import React, { ReactElement, memo } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'
import UnitSizeIcon from '../../assets/svg/unit-size.svg'
import { PropertyCardPropTypes } from './PropertyCard.types'
import './PropertyCard.scss'
import { isMP4 } from '../../services/validations'

const PropertyCard = ({
  data,
  className,
}: PropertyCardPropTypes): ReactElement => {
  const {
    featuredImage,
    optimizedFeaturedImg,
    gallery,
    propertyName,
    propertyLocation,
    propertyType,
    priceRange,
    floorAreaSize,
    slug,
  } = data

  let filteredData
  if (
    isMP4(featuredImage) &&
    !(optimizedFeaturedImg?.childImageSharp) &&
    gallery
  ) {
    filteredData = gallery?.find(
      (galleryItem) => galleryItem.type === 'image' || !isMP4(galleryItem.url),
    )
  }

  const thumbnail = gallery?.find((item) => {
    const regex = /\bthumbnail\b/i
    const isThumbnailPresent = regex.test(item?.description || '')
    return isThumbnailPresent
  })

  const filterType = propertyType?.toLowerCase().replace(/\s+/g, '-') || 'property'

  return (
    <Link
      to={
        filterType !== 'office'
          ? `/properties/${filterType}/${slug}/`
          : `/properties/${slug}`
      }
      className="property-card-link"
    >
      <div className={`property-card${className ? ` ${className}` : ''}`}>
        {thumbnail && thumbnail?.optimizedGalleryImg ? (
          <div className="property-card-lazy">
            <GatsbyImage
              image={getImage(thumbnail?.optimizedGalleryImg)!}
              alt="Property thumbnail"
              loading="lazy"
              className="property-card-header"
            />
            <span className="property-card-lazy-img__type">{propertyType}</span>
            {priceRange && (
              <p className="property-card-lazy-img__price-range">
                Price Range <br />
                <span className="property-card-lazy-img__price-range-value">
                  {priceRange}
                </span>
              </p>
            )}
          </div>
        ) : (thumbnail && thumbnail?.url) ||
          (filteredData && filteredData?.url) ? (
          <div className="property-card-lazy">
            <LazyLoadImage
              loading="lazy"
              src={thumbnail?.url || filteredData?.url}
              alt="Property thumbnail"
              className="property-card-header property-card-lazy-img"
            />
            <span className="property-card-lazy-img__type">{propertyType}</span>
            {priceRange && (
              <p className="property-card-lazy-img__price-range">
                Price Range <br />
                <span className="property-card-lazy-img__price-range-value">
                  {priceRange}
                </span>
              </p>
            )}
          </div>
        ) : optimizedFeaturedImg?.childImageSharp?.fluid ? (
          <BackgroundImage
            className="property-card-header"
            fluid={optimizedFeaturedImg.childImageSharp.fluid}
          >
            <span className="property-card-type">{propertyType}</span>
            {priceRange && (
              <p className="price-range">
                Price Range <br />
                <span className="price-range-value">{priceRange}</span>
              </p>
            )}
          </BackgroundImage>
        ) : optimizedFeaturedImg?.childImageSharp ? (
          <div className="property-card-lazy">
            <GatsbyImage
              image={getImage(optimizedFeaturedImg.childImageSharp)!}
              alt="Property thumbnail"
              loading="lazy"
              className="property-card-header"
            />
            <span className="property-card-lazy-img__type">{propertyType}</span>
            {priceRange && (
              <p className="property-card-lazy-img__price-range">
                Price Range <br />
                <span className="property-card-lazy-img__price-range-value">
                  {priceRange}
                </span>
              </p>
            )}
          </div>
        ) : featuredImage ? (
          <div className="property-card-lazy">
            <LazyLoadImage
              loading="lazy"
              src={featuredImage}
              alt="Property thumbnail"
              className="property-card-header property-card-lazy-img"
            />
            <span className="property-card-lazy-img__type">{propertyType}</span>
            {priceRange && (
              <p className="property-card-lazy-img__price-range">
                Price Range <br />
                <span className="property-card-lazy-img__price-range-value">
                  {priceRange}
                </span>
              </p>
            )}
          </div>
        ) : (
          <div
            className="property-card-header"
            style={{
              background: `linear-gradient(179deg, rgba(0,0,0,0.00) 58%, #000000 100%)`,
            }}
          >
            <span className="property-card-type">{propertyType}</span>
            {priceRange && (
              <p className="price-range">
                Price Range <br />
                <span className="price-range-value">{priceRange}</span>
              </p>
            )}
          </div>
        )}

        <div className="property-card-details">
          <div className="property-card-details__info">
            <h3>{propertyName || 'Unnamed Property'}</h3>
            <p>{propertyLocation || 'Location not specified'}</p>
          </div>
          <div className="size">
            <img src={UnitSizeIcon} alt="unit icon" /> {floorAreaSize || 'Size not available'}
          </div>
        </div>
      </div>
    </Link>
  )
}

export default memo(PropertyCard)
